module.exports = __webpack_public_path__ + "assets/img/picture1.4ea4879d.png";